module.exports = __webpack_public_path__ + "img/Logo-10.3d54b1ad.svg";